import { render, staticRenderFns } from "./MoleculeLandingCard.vue?vue&type=template&id=c5fab4f0&scoped=true&"
import script from "./MoleculeLandingCard.vue?vue&type=script&lang=js&"
export * from "./MoleculeLandingCard.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeLandingCard.vue?vue&type=style&index=0&id=c5fab4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fab4f0",
  null
  
)

export default component.exports